import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data.posts || [])).catch(() => {});
  }, []);

  return (
    <section
      id="blog"
      data-testid="blog-preview-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-6">
          <div className="max-w-2xl">
            <div className="text-xs tracking-[0.3em] uppercase text-[#1D4E89] font-medium mb-5">
              Journal
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-[#0B2B40] tracking-tight leading-tight font-light">
              Quiet writings on the inner work.
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-view-all"
            className="inline-flex items-center gap-2 text-[#0B2B40] text-sm font-medium border-b border-[#0B2B40] pb-1 hover:text-[#1D4E89]"
          >
            View all writings <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              data-testid={`blog-card-${p.id}`}
              className="group"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="mt-5 text-xs tracking-[0.2em] uppercase text-[#1D4E89]">
                {p.category} · {p.read_time}
              </div>
              <h3 className="font-serif text-2xl text-[#0B2B40] mt-3 leading-snug group-hover:text-[#1D4E89] transition-colors">
                {p.title}
              </h3>
              <p className="mt-3 text-[#4A5568] leading-relaxed">{p.excerpt}</p>
              <div className="mt-4 text-xs uppercase tracking-[0.18em] text-[#4A5568]">
                {p.date}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
